import * as fromCompanyManagementReducer from './company-management.reducer'

import { ActionReducerMap, createFeatureSelector } from '@ngrx/store'

import { ApplicationSettingsState } from '@app/features/company-management/features/application-settings/models'
import { CompanyManagementState } from '@app/features/company-management/models/company-management.state.model'
import { applicationSettingsReducer } from '@app/features/company-management/features/application-settings/store/application-settings.reducer'

export const featureKey = 'companyManagement'

export interface State {
  companyManagement: CompanyManagementState
  applicationSettings: ApplicationSettingsState
}

export const reducers: ActionReducerMap<State> = {
  companyManagement: fromCompanyManagementReducer.reducer,
  applicationSettings: applicationSettingsReducer,
}

export const getCompanyManagementState = createFeatureSelector<State>(featureKey)
